import { Component, DestroyRef, HostListener, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BroadcastService, PermissionService, UserService } from '@socrates/socrates-shared';

@Component({
	selector: 'app-header',
	templateUrl: './appHeader.component.html',
	standalone: false,
})
export class AppHeaderComponent {
	private readonly _accountMenuOpen = signal(false);
	private readonly destroyRef = inject(DestroyRef);

	constructor(
		private broadcastService: BroadcastService,
		private permissionService: PermissionService,
		private router: Router,
		private userService: UserService,
	) {
		this.broadcastService.getEmitter<any>('closeAccountMenu').pipe(
			takeUntilDestroyed(this.destroyRef)
		).subscribe(() => this._accountMenuOpen.set(false));
	}

	toggleAccountMenu(): void {
		this._accountMenuOpen.update(v => !v);
	}

	closeAccountMenu(): void {
		this._accountMenuOpen.set(false);
	}

	@HostListener('document:keydown.escape')
	onEscape(): void {
		this._accountMenuOpen.set(false);
	}

	openAccountSettings(): void {
		this.closeAccountMenu();
		this.router.navigateByUrl('/profile');
	}

	openAdminConfig(): void {
		this.closeAccountMenu();
		this.router.navigateByUrl('/admin/config');
	}

	logout(): void {
		this.closeAccountMenu();
		this.router.navigateByUrl('/logout');
	}

get accountMenuOpen(): boolean { return this._accountMenuOpen(); }

	get initials(): string {
		const user = this.userService.user;
		if (!user) return '';
		const f = user.firstName?.[0] ?? '';
		const l = user.lastName?.[0] ?? '';
		return (f + l).toUpperCase();
	}

	get fullName(): string {
		return this.userService.user?.fullName ?? '';
	}

	get email(): string {
		return this.userService.user?.username ?? '';
	}

	get hasAnyAdminAccess(): boolean {
		const user = this.userService.user;
		if (!user) return false;
		return (
			this.permissionService.permitted(user, 'IdeaManagement.ADMIN') ||
			this.permissionService.permitted(user, 'UserManagement.READ') ||
			this.permissionService.permitted(user, 'ModerationManagement.READ') ||
			this.permissionService.permitted(user, 'ReportingManagement.READ') ||
			this.permissionService.permitted(user, 'ConfigManagement.READ')
		);
	}
}
